import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event17 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpeg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "20px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    CWIS Master Trainers Strengthened Through Four-Day Capacity
                    Enhancement Workshop
                  </h2>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      padding: "20px 0",
                    }}
                  >
                    Date: 16–19 November 2025 Location: Dream Square Resort,
                    Gazipur
                  </p>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "20px 0",
                    }}
                  >
                    The CWIS-FSM Support Cell, in collaboration with WaterAid
                    Bangladesh and ITN-BUET, successfully organized a four-day
                    <strong>Capacity Enhancement Training</strong> for CWIS Master Trainers. A
                    total of <strong>39 master trainers from 37 municipalities</strong>
                    participated in the program, held from <strong>16–19 November 2025</strong>
                     &nbsp;at Dream Square Resort, Gazipur.
                  </p>

                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The workshop was designed to enhance participants’ technical
                    proficiency in developing <strong>Shit Flow Diagrams (SFD)</strong> and <strong>Waste
                    Flow Diagrams (WFD)</strong>—two essential tools for analyzing
                    sanitation service chains, identifying gaps, and informing
                    data-driven decisions for improving safely managed
                    sanitation services.
                  </p>

                  <h3>Opening Ceremony</h3>
                  <p style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>The event commenced with opening remarks from:</p>
                  <ul>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Dr. Abdullah-al-Muyeed,</strong> Chief Operating Officer, CWIS-FSM
                      Support Cell, DPHE
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Partha Hefaz Sheikh,</strong> Director – Policy and Advocacy,
                      WaterAid Bangladesh
                    </li>
                  </ul>
                  <p style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                    Both speakers highlighted the importance of SFD and WFD
                    tools in strengthening sanitation governance and emphasized
                    the growing need for municipalities to adopt evidence-based
                    approaches for planning and monitoring sanitation systems.
                  </p>

                  <h3>Training Highlights</h3>
                  <p style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                    The technical sessions were led by experts from the CWIS-FSM
                    Support Cell, ITN-BUET, and WaterAid Bangladesh.
                  </p>
                  <ul>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      <strong>Md. Tawhidur Rahaman,</strong> Technical Expert, CWIS-FSM Support
                      Cell, conducted key sessions introducing the concepts of
                      SFD and WFD, highlighting how these tools support
                      municipal planning, performance monitoring, and strategic
                      decision-making.
                    </li>
                    <li style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}>
                      Trainers from <strong>ITN-BUET</strong> and <strong>WaterAid Bangladesh</strong> facilitated
                      hands-on exercises, enabling participants to practice
                      developing SFDs and WFDs using real municipal data and
                      validated methodologies.
                    </li>
                  </ul>
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    Throughout the training, participants engaged in practical
                    group work, case studies, and tool- based exercises designed
                    to strengthen their technical confidence and analytical
                    capabilities.
                  </p>
                  <h3>Commitment and Next Steps</h3>
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    <br />
                    At the conclusion of the workshop, master trainers committed
                    to developing SFDs and WFDs for their respective
                    municipalities over the coming months. They will work
                    closely with WaterAid Bangladesh and the CWIS-FSM Support
                    Cell to review, finalize, and upload these diagrams to
                    national and global platforms, contributing to improved
                    sanitation governance across Bangladesh. The event marked
                    another significant step toward strengthening municipal
                    capacity under the CWIS framework and fostering data-driven
                    approaches to achieve inclusive and sustainable sanitation
                    services.
                  </p>
                  <Row>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height: "550px",
                            objectFit: "contain",
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news27/1.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                            height: "550px",
                            objectFit: "contain",
                          }}
                          src={
                            process.env.PUBLIC_URL +
                            `/assets/images/news27/2.jpeg`
                          }
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event17;
